import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=72744cef&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"
import style0 from "./mobile.vue?vue&type=style&index=0&id=72744cef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72744cef",
  null
  
)

export default component.exports